












































import { Component, Vue, Prop } from 'vue-property-decorator'
import firebase from '@/plugins/firebase'
import { Group } from '@/models/group'
import { logAdd } from '@/models/log'

@Component
export default class CompanyGroupUpdateDescription extends Vue {
  @Prop({ type: Object, required: true }) doc!: firebase.firestore.QueryDocumentSnapshot<Group>

  menu = false
  description = this.item.description

  get item (): Group {
    return this.doc.data()
  }

  save (): void {
    this.doc.ref.set({ description: this.description }, { merge: true })
    this.menu = false
    logAdd('update', '그룹 설명 변경', `${this.item.description} => ${this.description}`, 'admin')
  }
}
